function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import MuiButton from '@material-ui/core/Button';

var InputButtonComponent = function InputButtonComponent(_ref) {
  var classesProp = _ref.classes,
      others = _objectWithoutProperties(_ref, ["classes"]);

  var containedClass = classesProp.contained,
      containedPrimaryClass = classesProp.containedPrimary,
      disabledClass = classesProp.disabled,
      otherClasses = _objectWithoutProperties(classesProp, ["contained", "containedPrimary", "disabled"]);

  return (
    /*#__PURE__*/
    React.createElement(MuiButton, _extends({}, others, {
      classes: _objectSpread({
        contained: containedClass,
        containedPrimary: containedPrimaryClass,
        disabled: disabledClass
      }, otherClasses),
      color: "primary",
      size: "medium",
      variant: "contained"
    }))
  );
};

var styles = function styles(theme) {
  return {
    /* End Button padding */
    contained: {
      minWidth: 0,
      height: 33,
      padding: '10px 16px',
      whiteSpace: 'nowrap'
    },
    containedPrimary: {
      zIndex: 1,
      '&$disabled': {
        color: theme.colors.neutral200,
        backgroundColor: theme.colors.theme300
      }
    },
    disabled: {}
  };
};

export var InputButton = withStyles(styles)(InputButtonComponent);